import { makeStyles } from '@material-ui/core/styles';
import variables from 'static/styles/jss/abstracts/variables';
import { MediaQuery } from 'static/styles/jss/abstracts/mixins';

export default makeStyles({
  'safety-info--list-block': {
    '& .sft-info-list--item': {
      backgroundColor: variables.$contentBlueColor,
      display: 'grid',
      padding: '20px',
      gridTemplateColumns: '150px 1fr',
      borderRadius: '4px',
      marginBottom: '20px',
      ...MediaQuery.down({
        gridTemplateColumns: '1fr',
      }).xss,
    },
    '& .list--item-image--wrapper': {
      '& img': {
        maxWidth: '100%',
        ...MediaQuery.down({
          width: '100%',
          marginBottom: '16px',
        }).xss,
      },
    },
    '& .lost--item-info-side': {
      paddingLeft: '20px',
      ...MediaQuery.down({
        paddingLeft: '0px',
      }).xss,
      '& a': {
        color: '#fff',
        textDecoration: 'underline !important',
        fontSize: '13px',
      },
    },
  },
});
